import { useCallback } from 'react';

import { usePaginatedAutocomplete } from '@app/hooks/use-autocomplete';

import AutocompleteField from '../../../autocomplete-field';
import { FilterComponentProps } from '../../types';


export function AutocompletePaginatedFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;

  const fetch = usePaginatedAutocomplete();

  const onFetchOptions = useCallback(async (name: string, query: Record<string, string>) => {
    const options = await fetch(name, query);
    return filter.onOptionsFetch ? filter.onOptionsFetch(options) : options;
  }, [fetch]);

  return <AutocompleteField
    id={filter.name.toString()} 
    name={filter.source}
    label={filter.label} 
    value={(filter.value as EntityBase)?.name}   
    onFetchOptions={onFetchOptions}
    onChange={(value) => {
      onChange({
        ...filter,
        value,
      });
    }}
  />;
}